import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslatorService } from '../../../helpers/getTranslationsHelper/translator.service';
import { GroupEventsService } from '../../../services/group-events.service';

export interface Filters {
  starts_after?: startsAfterFilter;
  ends_before?: endsBeforeFilter;
}

export type startsAfterFilter = null | string;
export type endsBeforeFilter = null | string;

export interface ReloadData {
  reload: boolean,
  filters: Filters
}

@Component({
  selector: 'app-group-custom-statistics',
  templateUrl: './group-custom-statistics.component.html',
  styleUrls: ['./group-custom-statistics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupCustomStatisticsComponent implements OnInit, OnDestroy {
  @Output() updateData = new EventEmitter<ReloadData>()
  @Output() clearAllData = new EventEmitter<boolean>()

  public filters: Filters;
  public clearArrays: boolean = false;
  public titleTranslated$: Observable<any>;

  public datesRange: string | null = null;

  constructor(
    private translatorService: TranslatorService,
    private groupEventsService: GroupEventsService,) { }

  ngOnInit() {
    this.titleTranslated$ = this.translatorService.getToasterTranslation(['SENSORS.CUSTOM_SENSOR_STATS']).pipe(map(res => res['SENSORS.CUSTOM_SENSOR_STATS']))
  }

  /**
   * 
   * @param $e Filters
   * {
        starts_after?: startsAfterFilter;
        ends_before?: endsBeforeFilter;
      }
   */
  changeFilters($e: Filters) {
    this.clearAllData.emit(true)
    this.changeData()

    this.filters = {
      starts_after: $e.starts_after,
      ends_before: $e.ends_before
    }

    this.datesRange = `${moment(this.filters.starts_after).format('DD-MM-YYYY')} - ${moment(this.filters.ends_before).format('DD-MM-YYYY')}`

    this.reloadData(true)
  }

  /**
   * 
   * @param $e Boolean
   * @description If this is true then we need to reload the data . 
   * So we need to send signal to parent component.
   */
  reloadData($e: boolean) {
    // console.log(`Reload Data? : ${$e}`)
    this.updateData.emit({ reload: $e, filters: this.filters })
  }

  clearData($e: boolean) {
    // console.log(`Clear Data? : ${$e}`)
    this.clearAllData.emit($e)
    this.changeData()
  }

  changeData() {
    this.filters = { starts_after: null, ends_before: null }
    this.clearArrays = !this.clearArrays;
    this.groupEventsService.setCustomStats([])
  }

  ngOnDestroy() {
    this.changeData()
  }

}
